import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '../../../create-aufgabe-dialog/create-aufgabe.formservice';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-lfpr-blattabschrift-editor',
	templateUrl: './aufgabe-lfpr-blattabschrift-editor.component.html',
	styleUrls: ['./aufgabe-lfpr-blattabschrift-editor.component.scss'],
	standalone: false,
})
export class AufgabeLfprBlattabschriftEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	protected readonly formGroup = this.formService.form.controls.LFPR_BLATTABSCHRIFT;
	protected readonly bodyControls = this.formGroup.controls.body.controls;
	protected readonly einfacheControls = this.bodyControls.einfache.controls;
	protected readonly beglaubigteControls = this.bodyControls.beglaubigte.controls;
	protected readonly AufgabenTyp = AufgabenTyp;
}
